/**
 * API Configuration
 * Centralizes API URL and configuration for the application
 */

// Get API URL from environment variable with fallback
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  AUTH_LOGIN: '/auth/login',
  AUTH_REGISTER: '/auth/register',
  AUTH_LOGOUT: '/auth/logout',
  AUTH_REFRESH: '/auth/refresh',
  
  // Leads
  LEADS: '/leads',
  LEADS_BY_ID: (id: string) => `/leads/${id}`,
  LEADS_SEARCH: '/leads/search',
  LEADS_EXPORT: '/leads/export',
  LEADS_IMPORT: '/leads/import',
  
  // Users
  USERS: '/users',
  USERS_BY_ID: (id: string) => `/users/${id}`,
  
  // Assignments
  ASSIGNMENTS: '/assignments',
  ASSIGNMENTS_BY_ID: (id: string) => `/assignments/${id}`,
  
  // Reports
  REPORTS_STATS: '/reports/stats',
  REPORTS_ACTIVITY: '/reports/activity',
  
  // Organizations
  ORGANIZATIONS: '/organizations',
  
  // Settings
  SETTINGS_PROFILE: '/settings/profile',
  
  // Health
  HEALTH: '/health',
};

// Axios configuration options
export const AXIOS_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for CORS with credentials
};

// Log API configuration (development only)
if (process.env.NODE_ENV === 'development') {
  console.log('🔗 API Configuration:');
  console.log('   Base URL:', API_BASE_URL);
  console.log('   With Credentials:', AXIOS_CONFIG.withCredentials);
  console.log('   Timeout:', AXIOS_CONFIG.timeout, 'ms');
}